export const config = {
  appWordpressUrl: process.env.VUE_APP_WORDPRESS_URL,
  appImgUrl: process.env.VUE_APP_IMG_URL
};
